import { useEffect, useState } from "react";
import useWindowDimensions from "helpers/screen";
import ChangeIndicator from "../../Secondary/ChangeIndicator";
import CryptoIcon from "../../Secondary/CryptoIcon";
import "./style.scss";
import { formatNumber } from "helpers/helpers";
import { useSelector } from "react-redux";


const AssetsList = ({searchSettings}) => {
  const {width} = useWindowDimensions();
  const state = useSelector((state) => state.storage);
  const [assets, setAssets] = useState([]);
  useEffect(() => {
    if (state.publicKey && state.accounts) {
      let rawAssets = state.accounts;
      setAssets(rawAssets);
    }
  }, [state.publicKey, state.accounts])

  return <div className="assetsList">
    <div className="titles">
      <p>Name</p>
      <p>Value</p>
      <p>Balance</p>
      <p>Price</p>
      <p>24h Change</p>
      <p>24h Volume</p>
      <p>Market Cap</p>
    </div>
    <div className="table">
      {
        assets
        .filter(x => {
          let {searchValue} = searchSettings;
          if (!(
            (x.symbol && x.symbol.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1) ||
            (x.tokenInfo && x.tokenInfo.name && x.tokenInfo.name.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1) ||
            (x.mint && x.mint.indexOf(searchValue) !== -1)
          ))
          return false;
          if (searchSettings.showZeroBalances == 1 && x.usdValue == 0)
            return false;
          if (searchSettings.showLowValueAssets == 1 && x.usdValue < 0.01)
            return false;
          return true;
        })
        .map((item, i) => {
          return <div key={i} className="item">
            <div className="flex">
              <CryptoIcon symbol={item.symbol} size={16}/>
              <p className="tickerName">{item.symbol}</p>
            </div>
            <p className="value">${item.usdValue < 0.00001 ? "~0.0" : formatNumber(item.usdValue, "auto")}</p>
            <p className="balance">{formatNumber(item.balance, "auto")}</p>
            <p className="price">${formatNumber(item.price, "auto")}</p>
            {
              width > 768 ?
              <ChangeIndicator change={{percentage:item.change, amount: item.changeAmount}}/>
              :
              <ChangeIndicator change={{percentage:item.change, amount: item.changeAmount}} showFull={false}/>
            }
           
            <p className="volume">${formatNumber(item.volume, "auto")}</p>
            <p className="mcap">${formatNumber(item.marketCap, "auto")}</p>
          </div>
        })
      }
    </div>
  </div>
}

export default AssetsList;